export default "__VITE_ASSET__SFDiv83Xnc7bN3DcIl_40w__"